import { memo, useEffect } from 'react';
import Processing from '@wg/wows-react-uikit/components/Processing/Processing';

import dwhExport, { DWH_EVENTS } from '~/dwhExport';
import { useAppSelector } from '~/store';
import { isGlobalFetchingSelector } from '~/store/selectors/fetchingCounterSelectors';
import { clanMembersPageSelector } from '~/store/selectors/pageClanMembersSelectors';

import ClanRatings from '~/Components/ClanRatings/ClanRatings';

import styles from './ClanMembers.module.scss';
import ClanMembersTable from './ClanMembersTable';

import type { ICurrentAccountState } from '~/store/slices/currentAccountSlice';

interface ClanMembersContentProps {
  clanId: number;
  currentAccount: ICurrentAccountState;
  isFromSearch: boolean;
}

const ClanMembersContent = ({ clanId, currentAccount, isFromSearch }: ClanMembersContentProps) => {
  const { isFetchingMembers, members, membersError, selectedMemberIds, sort, disabledIds, statistics } = useAppSelector(
    (state) => clanMembersPageSelector(state, clanId),
  );
  const isGlobalFetching = useAppSelector(isGlobalFetchingSelector);

  useEffect(() => {
    if (members.length && currentAccount.clanId === clanId && !isFromSearch) {
      dwhExport.push(DWH_EVENTS.MEMBERS.OPEN_PAGE);
    }
  }, [currentAccount.clanId, clanId, isFromSearch, members.length]);

  if (isGlobalFetching) {
    return null;
  }

  if (!members.length) {
    return <Processing isFetching className={styles.processing} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.profileRatings}>
        <ClanRatings clanId={clanId} dropdownPosition={'bottom'} />
      </div>

      <ClanMembersTable
        clanId={clanId}
        currentAccount={currentAccount}
        disabledIds={disabledIds}
        isFetchingMembers={isFetchingMembers}
        members={members}
        membersError={membersError}
        selectedMemberIds={selectedMemberIds}
        statistics={statistics}
        sort={sort}
      />
    </div>
  );
};

export default memo(ClanMembersContent);
